// InstallPrompt (admin) — same overlay as user but with worker-tinted copy.

import {
  FogLayer,
  Hairline,
  Han,
  PlatformEdge,
  RailLayer,
  ShareIcon,
  T,
  TextBtn,
} from "@goodbye/ui";
import type { InstallState } from "../hooks/useInstallPrompt";

export interface InstallPromptProps {
  state: InstallState;
  onAndroidInstall?: () => Promise<void>;
}

export function InstallPrompt({ state, onAndroidInstall }: InstallPromptProps) {
  return (
    <div
      style={{
        minHeight: "100dvh",
        position: "relative",
        background: T.paper,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <FogLayer opacity={0.6} />
      <RailLayer side="right" opacity={0.4} />
      <PlatformEdge bottom={108} opacity={0.3} />

      <div
        style={{
          position: "relative",
          zIndex: 1,
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "calc(54px + env(safe-area-inset-top, 0px)) 32px calc(32px + env(safe-area-inset-bottom, 0px))",
        }}
      >
        <Han size={13} color={T.ink500} ls="0.3em">
          再見。再見 · 工作端
        </Han>

        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 28,
          }}
        >
          <Han size={24} color={T.ink900} lh={1.6}>
            先 安 裝。<br />
            再 開 始。
          </Han>

          <Hairline />

          {state === "ios_add" && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 16,
              }}
            >
              <ShareIcon size={48} color={T.ink700} />
              <Han
                size={16}
                color={T.ink900}
                lh={1.7}
                style={{ textAlign: "center" }}
              >
                點分享 → 加入主畫面
              </Han>
            </div>
          )}

          {state === "android_native" && onAndroidInstall && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 16,
              }}
            >
              <TextBtn
                onClick={() => {
                  onAndroidInstall();
                }}
                mono={false}
                size={16}
                ls="0.3em"
                color={T.ink900}
              >
                · 立 即 安 裝
              </TextBtn>
            </div>
          )}

          {state === "android_manual" && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 16,
              }}
            >
              <span
                style={{
                  fontFamily: T.mono,
                  fontSize: 48,
                  color: T.ink700,
                  lineHeight: 1,
                  letterSpacing: "0.2em",
                }}
              >
                ⋮
              </span>
              <Han
                size={16}
                color={T.ink900}
                lh={1.7}
                style={{ textAlign: "center" }}
              >
                打開選單 → 安裝應用程式
              </Han>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
